import { createContext } from "react";

// set the defaults
const RecentlyUpdatedContext = createContext({ recentlyUpdated: null });

export default RecentlyUpdatedContext;